export const CUSTOMER_ACTIVE_CONTEXT_KEY = 'pn_active_context';
export const CUSTOMER_LOGIN_ACCOUNT_TYPE_KEY = 'pn_login_account_type';
export const CUSTOMER_LOGIN_TYPE_MISMATCH_KEY = 'pn_login_type_mismatch';